module.exports = __webpack_public_path__ + "img/14.ed7e9b1c.png";